import {useEffect, useState} from 'react';
import {getMeganavHeight, hideLoadingOverlay} from '~/ViewInvitation/utils';

interface UseScrollToMeganavOptions {
  isViewInvitationPage?: boolean;
  scrollToPhotos?: boolean;
  onReady?: () => void;
  maxAttempts?: number;
  intervalMs?: number;
}

/**
 * Handles scrolling to meganav height and optionally to photos section
 * @param options Config options for the scroll behavior
 */
export const useScrollToMeganav = ({
  isViewInvitationPage,
  scrollToPhotos = false,
  onReady,
  maxAttempts = 30,
  intervalMs = 100,
}: UseScrollToMeganavOptions) => {
  const [meganavHeight, setMeganavHeight] = useState<number | null>(null);

  useEffect(() => {
    let ct = 0;
    const interval = setInterval(() => {
      ct++;
      const height = getMeganavHeight();
      setMeganavHeight(height);

      if (height === null || !isViewInvitationPage) {
        onReady?.();
        clearInterval(interval);
        return;
      }

      if (height >= 100 || ct === maxAttempts) {
        window.scrollTo({
          top: height,
          behavior: 'auto',
        });
        hideLoadingOverlay();

        if (scrollToPhotos) {
          const photosModule = document.body.querySelector('.photos__container');
          photosModule?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }

        onReady?.();
        clearInterval(interval);
      }
    }, intervalMs);

    return () => clearInterval(interval);
  }, [isViewInvitationPage, scrollToPhotos, onReady, maxAttempts, intervalMs]);

  return {meganavHeight};
};
